<template>
  <div class="personal_data">
    <div class="top_text">绝不会以任何形式向第三方透露你的身份信息</div>
    <div class="info_one flex">
      <div class="info_label">头像</div>
      <div class="info_value">
        <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
          :on-success="handleAvatarSuccess">
          <img v-if="personalInfo.headImage" :src="iconPath(personalInfo.headImage)" style="width: 100px; height: 100px"
            class="avatar" />
          <el-icon v-else class="avatar-uploader-icon">
            <Plus />
          </el-icon>
        </el-upload>
      </div>
    </div>
    <div class="info_one flex">
      <div class="info_label">
        <!-- <span class="require_icon">*</span> -->
        昵称
      </div>
      <div class="info_value">
        <el-input v-model="personalInfo.name" style="width: 240px" size="large" placeholder="请输入" />
      </div>
    </div>
    <div class="info_one flex">
      <div class="info_label">
        <!-- <span class="require_icon">*</span> -->
        常用邮箱
      </div>
      <div class="info_value flex Flexalign">
        <el-input v-model="personalInfo.email" style="width: 240px" size="large" placeholder="请输入" />
        <!-- <div class="btn_save">保存</div> -->
      </div>
    </div>
    <div class="info_one flex">
      <div class="info_label">
        <!-- <span class="require_icon">*</span> -->
        手机账号
      </div>
      <div class="info_value">
        <div class="flex Flexalign">
          <div>{{ personalInfo.phone }}</div>
          <div class="active_text cursor_pointer" @click="changePhone">更换手机</div>
        </div>
        <div class="attention_text">用于优质内容推荐及活动题型，该信息不会对外公开</div>
      </div>
    </div>
    <!-- <div class="info_one flex">
      <div class="info_label">真实姓名</div>
      <div class="info_value">
        <el-input
          v-model="personalInfo.userName"
          style="width: 240px"
          size="large"
          placeholder="请输入真实姓名"
        />
        <div class="attention_text">用于证书上的名字，如不填写，则默认未昵称</div>
      </div>
    </div> -->
    <div class="info_one flex">
      <div class="info_label">性别</div>
      <div class="info_value">
        <el-radio-group v-model="personalInfo.sex">
          <el-radio value="男" size="large">男</el-radio>
          <el-radio value="女" size="large">女</el-radio>
          <!-- <el-radio value="2" size="large">其他</el-radio> -->
        </el-radio-group>
      </div>
    </div>
    <div class="info_one flex">
      <div class="info_label">生日</div>
      <div class="info_value">
        <!-- <el-input v-model="personalInfo.birthday" style="width: 240px" size="large" placeholder="请输入" /> -->
        <el-date-picker v-model="personalInfo.birthday" :disabled-date="disabledDate" value-format="YYYY-MM-DD"
          type="date" placeholder="选择你的生日" size="large" />
      </div>
    </div>
    <div class="info_one flex">
      <div class="info_label">
        <!-- <span class="require_icon">*</span> -->
        身份类型
      </div>
      <div class="info_value">
        <el-radio-group v-model="personalInfo.personType">
          <el-radio v-for="(item, index) in userPersonList" :key="index" :value="item.dictName" size="large">
            {{ item.dictName }}
          </el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="info_one flex">
      <div class="info_label">学校</div>
      <div class="info_value">
        <el-input v-model="personalInfo.schoolName" style="width: 240px" size="large" placeholder="请输入学校名称" />
      </div>
    </div>
    <div class="info_one flex">
      <div class="info_label">
        <!-- <span class="require_icon">*</span> -->
        最高学历
      </div>
      <div class="info_value">
        <el-radio-group v-model="personalInfo.topEducation">
          <el-radio v-for="(item, index) in educationalList" :key="index" :value="item.dictName" size="large">
            {{ item.dictName }}
          </el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="info_one flex">
      <div class="info_label">个人简介</div>
      <div class="info_value">
        <el-input v-model="personalInfo.personalSign" style="width: 400px;" size="large" type="textarea"
          placeholder="请输入个人简介" />
      </div>
    </div>
    <div class="btn_save_new cursor_pointer" @click="updatePersonalInfo">保存</div>
    <verify ref="verify"></verify>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as config from "@/config/config";
import verify from "@/components/popup/verify.vue";
export default {
  name: "GjkcH5PersonalData",
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  components: {
    verify,
  },
  watch: {
    userInfo: {
      handler() {
        this.personalInfo = this.$Tools.copyObj(this.userInfo);
      },
      deep: true
    },
  },

  data() {
    return {
      personalInfo: {},
      uploadUrl: "",
      educationalList: [], // 最高学历列表
      userPersonList: [], // 用户身份列表
    };
  },

  mounted() {
    this.uploadUrl = config.COMMON_UPLOAD_URL;
    // this.personalInfo = this.$Tools.copyObj(this.userInfo);
    this.getUserInfo();
    this.getDictList("userTopEducation");
    this.getDictList("userPersonType");
  },

  methods: {
    getUserInfo() {
      this.$Api.login.getUserInfo().then((response) => {
        this.personalInfo = response.data.data;
      });
    },
    // 获取最高学历字典
    getDictList(dictName) {
      this.$Api.common.getDictList({ dictName: dictName }).then((res) => {
        if (dictName == "userTopEducation") {
          this.educationalList = res.data.data;
        } else if (dictName == "userPersonType") {
          this.userPersonList = res.data.data;
        }
      });
    },
    disabledDate(time) {
      // 获取当前日期
      const today = new Date();
      today.setHours(0, 0, 0, 0); // 将时间设置为0点，确保比较时不考虑具体时间
      // 比较传入的日期是否大于今天
      return time.getTime() > today.getTime();
    },
    handleAvatarSuccess(response) {
      this.personalInfo.headImage = response?.data?.url;
    },
    changePhone() {
      this.$refs.verify.verifyShow = true;
      this.$refs.verify.phone = this.personalInfo.phone;
    },
    updatePersonalInfo() {
      let params = {
        atStageIds: "",
        atSubjectIds: "",
        birthday: this.personalInfo.birthday,
        email: this.personalInfo.email,
        headImage: this.personalInfo.headImage,
        name: this.personalInfo.name,
        personType: this.personalInfo.personType,
        personalSign: this.personalInfo.personalSign,
        provinceCode: "",
        schoolName: this.personalInfo.schoolName,
        sex: this.personalInfo.sex,
        topEducation: this.personalInfo.topEducation,
        // userName: this.personalInfo.userName,
      };
      // 暂不做必填需求
      // if (!params.email) {
      //   this.$Dialog.toast("请输入邮箱", { type: "warning" });
      //   return;
      // } else if (!params.name) {
      //   this.$Dialog.toast("请输入昵称", { type: "warning" });
      //   return;
      // } else if (!params.topEducation) {
      //   this.$Dialog.toast("请选择最高学历", { type: "warning" });
      //   return;
      // } else if (!params.personType) {
      //   this.$Dialog.toast("请选择身份类型", { type: "warning" });
      //   return;
      // }
      this.$Api.user
        .updatePersonalInfo(params)
        .then((res) => {
          console.log(res);
          this.$Api.login.getUserInfo().then((response) => {
            this.$Dialog.toast("保存成功");
            this.$store.commit("setUserInfo", response.data.data);
          });
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.personal_data {
  .top_text {
    font-size: 14px;
    color: #999999;
    margin: 15px 0;
  }

  .info_one {
    margin-top: 20px;

    .info_label {
      font-size: 16px;
      color: #333333;
      width: 100px;
      font-weight: 600;
      line-height: 35px;

      .require_icon {
        color: red;
      }
    }

    .info_value {
      :deep(.avatar-uploader .avatar) {
        width: 100px;
        height: 100px;
        display: block;
      }

      :deep(.avatar-uploader .el-upload) {
        border: 1px dashed #ccc;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        transition: var(--el-transition-duration-fast);
      }

      :deep(.avatar-uploader .el-upload:hover) {
        border-color: var(--el-color-primary);
      }

      :deep(.el-icon.avatar-uploader-icon) {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        text-align: center;
      }

      .btn_save {
        width: 109px;
        height: 34px;
        background: linear-gradient(90deg, #00d5c2, #00d498);
        border-radius: 5px;
        margin-left: 20px;
        color: #ffffff;
        text-align: center;
        line-height: 34px;
      }

      .active_text {
        color: #13d6aa;
        margin-left: 15px;
      }

      .attention_text {
        font-size: 14px;
        color: #999999;
        margin-top: 15px;
      }
    }
  }

  .btn_save_new {
    width: 109px;
    height: 34px;
    background: linear-gradient(90deg, #00d5c2, #00d498);
    border-radius: 17px;
    color: #ffffff;
    text-align: center;
    line-height: 34px;
    margin-top: 40px;
  }
}
</style>
